module.exports = __webpack_public_path__ + "img/icon-eye-open.4b5cfbdd.svg";